import React from 'react';
import classNames from 'classnames';
type ArtifactViewCodeDiffDisplayProps = {
  text: string;
  type: string;
};
const ArtifactViewCodeDiffDisplay: React.SFC<ArtifactViewCodeDiffDisplayProps> = props => {
  let text = props.text,
    type = props.type,
    colorClasses = classNames({
      'col-1-1 ph pv---': true,
      'font-family--code': true,
      'color--muted': type === 'comment',
      'bg-color--deleted': type === 'delete',
      'bg-color--added': type === 'add',
    }),
    icon;
  if (type === 'delete') {
    icon = <div className="position--absolute left--5 unselectable">{'\u2212'}</div>;
  } else if (type === 'add') {
    icon = <div className="position--absolute left--5 unselectable">{'\u002B'}</div>;
  }
  return (
    <div className={colorClasses}>
      <div className="grid grid--middle">
        <div className="grid__item col-1-24 position--relative">{icon}</div>
        <div className="grid__item col-23-24 font--12">{text}</div>
      </div>
    </div>
  );
};
export default ArtifactViewCodeDiffDisplay;
